/**
 * Alert "riproposta di reso": gli omaggi sono spesso sostituzioni di merce
 * scaduta che il cliente dovrebbe distruggere. Se lo stesso articolo è già
 * stato dato in omaggio nei 18 giorni precedenti con quantità uguale o ±1,
 * è probabile che il cliente stia riproponendo lo stesso reso.
 */
export const OMAGGI_WINDOW_DAYS = 18;
export const OMAGGI_QTY_TOLERANCE = 1;

const withinWindow = (iso) => {
  if (!iso) return false;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return false;
  return Date.now() - t <= OMAGGI_WINDOW_DAYS * 24 * 3600 * 1000;
};

/**
 * Ritorna {qta, data, source} se l'omaggio inserito (qtyOm) è uguale/simile
 * (±1) a un omaggio recente per lo stesso articolo, altrimenti null.
 *
 * Fonti controllate:
 *  - `recentOmaggio`: omaggio più recente dagli ordini app (endpoint /recent-omaggi)
 *  - `product.ultimo_reso_qta/_data`: ultimo reso dallo storico giri importato
 */
export function checkOmaggioConflict(product, qtyOm, recentOmaggio) {
  const om = Number(qtyOm) || 0;
  if (om <= 0) return null;
  if (recentOmaggio && withinWindow(recentOmaggio.data)
      && Math.abs(om - (Number(recentOmaggio.qta) || 0)) <= OMAGGI_QTY_TOLERANCE) {
    return { qta: Number(recentOmaggio.qta) || 0, data: recentOmaggio.data, source: "ordine" };
  }
  if (product?.ultimo_reso_data && withinWindow(product.ultimo_reso_data)
      && Math.abs(om - (Number(product.ultimo_reso_qta) || 0)) <= OMAGGI_QTY_TOLERANCE) {
    return { qta: Number(product.ultimo_reso_qta) || 0, data: product.ultimo_reso_data, source: "storico" };
  }
  return null;
}
